const CachingController = () => {
    return null;
};

export default CachingController;
